var React = require('react');

function BoxFragile (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-96 160c0 47.5-34.6 86.7-80 94.4V384h40a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h40v-97.6a95.78 95.78 0 0 1-80-94.4v-80a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 192c0 47.5-34.6 86.7-80 94.4V384h40a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h40v-97.6a95.78 95.78 0 0 1-80-94.4v-80a16 16 0 0 1 16-16h60.4l24.5 27.6-64 32 91 68.4-37-59.6 64-32L260.1 96H304a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

BoxFragile.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = BoxFragile;

BoxFragile.default = BoxFragile;
